import { Flex } from "@common/components/Flex";
import { I18n } from "react-redux-i18n";
import { getTestAttributes } from "@common/utils/tests";
import { MODULE_NAME } from '@modules/individuals';
import { FormControl } from "@common/components/form-control";

import "./email-address.styles.scss";

export const EmailAddress = (props) => {
  const { defaultValue, onChange } = props;
  const localModuleName = `${MODULE_NAME}-new-invite-email-address`;

  const handleBlur = React.useCallback((e) => {
    onChange(e.target.value.trim());
  }, [onChange]);

  return (
    <div className="IndividualsEmailAddress">
      <h6 className="IndividualsEmailAddress__title">{I18n.t("There is a problem with the email address for this individual, please enter a valid email address")}</h6>

      <Flex justify="center" width="100%">
        <FormControl
          defaultValue={defaultValue}
          type="text"
          onBlur={handleBlur}
          {...getTestAttributes(localModuleName, 'email', 'input')}
        />
      </Flex>
    </div>
  );
};
